import { c as _c } from "react/compiler-runtime";
import { connect } from 'react-redux';
import { useViewport } from '@sbt-web/hooks';
import { AdTypes, FilterURI } from '@sbt-web/network/types';
import { FormGroup, SelectBox, SelectOption, SelectOptionOptionType } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { updateAdType } from '@/reducers/search';
import { adTypesLabelsMap } from '@/shared/tools/search/values';
import { FilterLabel } from '../common/FilterLabel';
import type { CommonFilterProps } from '../common/types';
type StateProps = {
  currentAdType: AdTypes;
};
type DispatchProps = {
  updateAdType: (adType: AdTypes) => void;
};
type OwnProps = {
  adTypes: AdTypes[];
  trackSearchConversion: () => void;
};
type Props = CommonFilterProps & StateProps & DispatchProps & OwnProps;
const adTypesMap = new Map<string, SelectOptionOptionType>([[AdTypes.Sell, {
  name: adTypesLabelsMap[AdTypes.Sell],
  value: AdTypes.Sell
}], [AdTypes.Seek, {
  name: adTypesLabelsMap[AdTypes.Seek],
  value: AdTypes.Seek
}], [AdTypes.Rent, {
  name: adTypesLabelsMap[AdTypes.Rent],
  value: AdTypes.Rent
}], [AdTypes.VacationRent, {
  name: adTypesLabelsMap[AdTypes.VacationRent],
  value: AdTypes.VacationRent
}], [AdTypes.GiveAway, {
  name: adTypesLabelsMap[AdTypes.GiveAway],
  value: AdTypes.GiveAway
}]]);
export const AdTypeComponent = t0 => {
  const $ = _c(22);
  const {
    adTypes,
    currentAdType,
    showBadgeNew,
    trackSearchConversion,
    updateAdType
  } = t0;
  const {
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== adTypes) {
    t1 = adTypes.map(_temp);
    $[0] = adTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const valueListFromAdTypes = t1;
  let t2;
  if ($[2] !== trackSearchConversion || $[3] !== updateAdType) {
    t2 = options => {
      trackSearchConversion();
      return updateAdType(options[0].value as AdTypes);
    };
    $[2] = trackSearchConversion;
    $[3] = updateAdType;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSelection = t2;
  let t3;
  if ($[5] !== adTypes || $[6] !== currentAdType) {
    let t4;
    if ($[8] !== currentAdType) {
      t4 = t => t === currentAdType;
      $[8] = currentAdType;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = adTypes.findIndex(t4);
    $[5] = adTypes;
    $[6] = currentAdType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const index = t3;
  if (adTypes.length <= 1) {
    return null;
  }
  let t4;
  if ($[10] !== showBadgeNew) {
    t4 = <FilterLabel showBadgeNew={showBadgeNew}>Tipo di annuncio</FilterLabel>;
    $[10] = showBadgeNew;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== index) {
    t5 = [index];
    $[12] = index;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = isMobile ? "large" : "small";
  const t7 = valueListFromAdTypes as SelectOptionOptionType[];
  let t8;
  if ($[14] !== handleSelection || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <SelectBox name={FilterURI.AdType} type="radio" selectedIndices={t5} expanded={true} flavor={t6} valueList={t7} onSelect={handleSelection} />;
    $[14] = handleSelection;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t8) {
    t9 = <FormGroup>{t4}{t8}</FormGroup>;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export const AdTypeSelector = connect<StateProps, DispatchProps, OwnProps, RootState>((state: RootState, ownProps: OwnProps) => ({
  currentAdType: state.search.adType,
  trackSearchConversion: ownProps.trackSearchConversion
}), dispatch => ({
  updateAdType: (adType: AdTypes) => dispatch(updateAdType(adType))
}))(AdTypeComponent);
function _temp(adType) {
  return adTypesMap.get(adType);
}